import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/video.mp4'
import _imports_1 from '@/assets/01.png'
import _imports_2 from '@/assets/02.png'
import _imports_3 from '@/assets/03.png'
import _imports_4 from '@/assets/04.png'


const _withScopeId = n => (_pushScopeId("data-v-6ef7bbba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "con-farm" }
const _hoisted_2 = {
  key: 0,
  class: "video",
  width: "100%",
  autoplay: "",
  muted: "",
  loop: ""
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  src: _imports_0,
  type: "video/mp4"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "con-data"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("UNSTAKE")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("ADD MORE")
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "con-info" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titlex" }, "Earnings", -1))
const _hoisted_11 = { class: "valuex" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titlex" }, "Bizarre Platypus Staked", -1))
const _hoisted_13 = { class: "valuex" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titlex" }, "Unlock on", -1))
const _hoisted_15 = { class: "valuex" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Claim $CYRUS")
const _hoisted_17 = { class: "con-footer-info" }
const _hoisted_18 = { class: "infox" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titlex2" }, "Total Bizarre Platypus Staked", -1))
const _hoisted_20 = { class: "valuex2" }
const _hoisted_21 = { class: "infox not-line" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titlex2" }, "% of Bizarre Platypus Staked", -1))
const _hoisted_23 = { class: "valuex2" }
const _hoisted_24 = {
  key: 2,
  class: "con-btn-start-farm"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "STAKING", -1))
const _hoisted_26 = { class: "w-full text-center" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img01",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img02",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img03",
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img04",
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo2" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    width: "154.899",
    height: "67.362",
    viewBox: "0 0 154.899 67.362",
    class: "logo"
  }, [
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("clipPath", { id: "clip-path" }, [
        /*#__PURE__*/_createElementVNode("rect", {
          id: "Rectángulo_364",
          "data-name": "Rectángulo 364",
          width: "154.899",
          height: "67.362",
          transform: "translate(0 0)",
          fill: "none"
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("g", {
      id: "Grupo_807",
      "data-name": "Grupo 807",
      transform: "translate(0 0)"
    }, [
      /*#__PURE__*/_createElementVNode("g", {
        id: "Grupo_806",
        "data-name": "Grupo 806",
        "clip-path": "url(#clip-path)"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          id: "Trazado_13049",
          "data-name": "Trazado 13049",
          d: "M23.862,26.929c0,7.585-4.846,10.639-16.7,10.639H.895c-.421,0-.684-.421-.684-1.053,0,0,.263-12.114.263-19.225C.474,7.7,0,3.754,0,3.227,0,1.858,3.107.7,6.952.7c6.9,0,11.8,3.74,11.8,9.059A5.243,5.243,0,0,1,13.8,15.281c-.106.006-.212.009-.318.008,0,0,10.376.579,10.376,11.64M8.007,11.286q0,.631.948.632c1.527,0,2.739-.948,2.739-2.107,0-1.053-1.159-1.843-2.739-1.843-.632,0-.948.211-.948.579Zm0,16.8c0,.527.158.579,1.264.579,2.739,0,3.95-.632,4-2.054.052-1.527-1.37-2.212-4.477-2.212-.579,0-.79.158-.79.685Zm20.434,9.48c-.948,0-1.159,0-1.159-.526V2.967C27.282,1.756,33.076.7,37.763.7c.685,0,.9,0,.9,1.107V37.045c0,.526-.316.526-1.422.526ZM67.2,2.7v8.585a1.678,1.678,0,0,1-.527,1.37L55.828,25.874q-.87,1.105,0,1.106l38.445.293V37.567H43.452c-.79,0-1.369-.158-1.369-1.159V28.876a3.823,3.823,0,0,1,1.212-2.418l12.43-14.7c.263-.316.211-.474-.422-.474H44.242c-.368,0-1.159-.105-1.159-1.527V2.173C43.083.751,43.873.7,44.242.7H66.048c1.053,0,1.158.9,1.158,2m6.631,23.457H68.644c-.56,0-.859-.075-.635-.6L77.387,1.943C77.76,1.159,81.123,0,82.617,0c.411,0,.673.075.747.262l8.743,25.4c.038.15-.15.486-.785.486H86.315a1.353,1.353,0,0,1-1.158-.6c-.15-.374-1.083-4.969-1.606-5.006l-6.538-.336c-1.008-.037-2.2,4.67-2.466,5.417a.678.678,0,0,1-.709.523m5.193-12.329c-.261.523-.187.71.486.71h2.316c.224,0,.6-.15.374-.859L81.5,11.2c-.15-.561-.262-.859-.411-.859s-.337.3-.635.859Zm40.24,23.055c0,.684-.738.684-1.106.684H110.37a.934.934,0,0,1-.843-.474l-3.16-6.847c-.421-.9-.737-1.369-.948-1.369-.264,0-.369.474-.369,1.369v6.637c0,.684-.685.684-1.054.684H97.359c-.369,0-.9,0-.9-.684,0-2.476.422-8.48.422-16.012,0-7.479-.316-17.855-.316-18.224,0-1.317,4.53-1.949,8.533-1.949,6.637,0,11.377,3.74,11.377,9.744,0,6.32-5.214,8.69-7.269,8.69-.474,0-.421.158.053.842,1.159,1.738,10.007,15.38,10.007,16.907M104.729,12.326c0,.316.158.422.632.422a4.481,4.481,0,0,0,4.214-4.161c0-1.58-1.317-2.212-3.687-2.212-1,0-1.159.106-1.159.949Zm26.284,9.612c0,.393-.423.393-.635.393h-4.472a.535.535,0,0,1-.484-.272l-1.813-3.929c-.242-.514-.424-.786-.544-.786-.152,0-.212.272-.212.786v3.808c0,.393-.392.393-.6.393h-3.808c-.211,0-.513,0-.513-.393,0-1.421.242-4.865.242-9.187,0-4.291-.181-10.244-.181-10.456,0-.756,2.6-1.118,4.9-1.118,3.808,0,6.527,2.145,6.527,5.59a4.788,4.788,0,0,1-4.17,4.986c-.272,0-.241.091.031.484.664,1,5.741,8.824,5.741,9.7M122.681,7.855c0,.181.091.242.363.242a2.57,2.57,0,0,0,2.418-2.387c0-.906-.756-1.269-2.115-1.269-.575,0-.665.06-.665.544Zm21.8,22c.579,0,.843-.211.843-.737V22.692c0-.211-.053-.422-.264-.422h-4.53c-.369,0-.579-.263-.579-.79v-4.9a1.119,1.119,0,0,1,1.264-1.054H144.9V11.418c0-.316-.053-.737-.369-.737H132.944a.664.664,0,0,1-.684-.643V4.729c0-2.107.9-2.265,1.211-2.317a91.031,91.031,0,0,1,13.115-.843c2.159,0,7.585,1.106,7.585,2.318V37.069c0,.58,0,1.37-.737,1.37H121.609c-.515-.89-1.1-7.4.233-8.263Z",
          fill: "#ff0"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          id: "Trazado_13050",
          "data-name": "Trazado 13050",
          d: "M6.615,56.72c-.151,0-.226.036-.226.248V66.89c0,.461-.338.461-.6.461H.9c-.263,0-.639-.035-.639-.461.263-6.662.263-10.312.263-13,0-3.189,0-6.307-.263-9.5-.037-.461,2.633-1.843,5.756-1.843,6.584,0,10.008,2.2,10.008,6.414,0,4.465-3.875,7.76-9.4,7.76m3.762-8.044c0-1.524-2.107-1.665-2.972-1.665-.9,0-1.016.142-1.016.673v3.862c0,.177.037.319.376.319,1.2,0,3.612-1.559,3.612-3.189M17.9,44.07c0-.638,3.574-1.524,6.847-1.524.263,0,.564,0,.564.284,0,.567-1.128,11.906-1.128,14.387,0,1.1-.226,2.48.677,2.48,1.392,0,7.487-.886,8.39-.886.414,0,.564.142.564.6l-.3,7.477c0,.461-.527.461-1.053.461H18.5c-.264,0-.6,0-.6-.461ZM41.3,67.351H36.075c-.564,0-.865-.071-.64-.567l9.443-22.4c.376-.744,3.762-1.843,5.267-1.843.414,0,.677.071.753.248l8.8,24.1c.038.142-.15.461-.79.461H53.866a1.382,1.382,0,0,1-1.166-.567c-.15-.355-1.091-4.713-1.618-4.748L44.5,61.716c-1.016-.035-2.219,4.429-2.483,5.138a.68.68,0,0,1-.715.5M46.53,55.66c-.263.5-.188.674.489.674h2.332c.226,0,.6-.142.377-.815l-.715-2.338c-.15-.532-.263-.816-.414-.816s-.339.284-.64.816ZM78.51,42.549A1.362,1.362,0,0,1,79.8,43.982c0,.031,0,.061-.008.091v3.3c0,1.488-.263,1.807-1.58,1.807h-6.4c-.451,0-.489.142-.489.461,0,6.094.263,11.445.564,17.221.038.5-.3.5-.753.5H65c-.451,0-.79-.035-.753-.5.339-5.776.564-11.127.564-17.221,0-.284-.038-.461-.564-.461H57.705c-1.317,0-1.354-.567-1.354-1.913v-3.26c0-.957.414-1.453,1.2-1.453Zm8.2,0c.452,0,.489.39.565.532L90.4,50.77c.075.177.188.177.263,0l2.747-7.689c.112-.284.226-.532.6-.532h4.477c.451,0,.6.177.489.532L94.61,55.058a7.346,7.346,0,0,0-.188,1.311V66.71c0,.532-.263.638-.715.638h-6.32c-.6,0-.865-.177-.865-.638V56.366a7.7,7.7,0,0,0-.452-1.312L81.706,43.077c-.113-.284.151-.532.677-.532Zm20.581,14.174c-.151,0-.226.036-.226.248v9.922c0,.461-.339.461-.6.461h-4.891c-.263,0-.639-.035-.639-.461.263-6.662.263-10.312.263-13,0-3.189,0-6.307-.263-9.5-.038-.461,2.633-1.843,5.756-1.843,6.584,0,10.008,2.2,10.008,6.414,0,4.465-3.875,7.76-9.406,7.76m3.762-8.044c0-1.524-2.107-1.665-2.972-1.665-.9,0-1.016.142-1.016.673V51.55c0,.177.037.319.376.319,1.2,0,3.612-1.559,3.612-3.189m7.526,7.69v-12.8c0-1.028,1.731-1.028,2.784-1.028,1.392,0,3.2.248,3.2.921V56.578c0,3.721,1.43,4.394,3.01,4.394s3.236-.673,3.236-4.394V43.538c0-.744.865-.992,2.821-.992,1.241,0,3.16,0,3.16.638V56.65c0,9.32-3.725,10.7-9.1,10.7s-9.1-2.091-9.1-10.985m19.715,8.965V62.318c0-1.24.264-1.453.828-1.559,2.069-.355,9.067.744,9.067-2.41,0-3.614-9.142-1.595-9.142-8.54,0-5.457,5.681-7.264,10.873-7.264a20.744,20.744,0,0,1,3.386.248c1.279.213,1.58.39,1.58,1.559v2.162c0,.956,0,1.417-1.467,1.169a17.633,17.633,0,0,0-3.085-.284c-2.709,0-3.912.886-3.912,2.374,0,3.969,8.39,1.843,8.39,10.134,0,6.1-4.515,7.406-9.255,7.406a50.33,50.33,0,0,1-5.945-.461c-1.053-.142-1.317-.354-1.317-1.524",
          fill: "#00ff62"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          id: "Trazado_13051",
          "data-name": "Trazado 13051",
          d: "M144.479,29.875c.579,0,.843-.211.843-.737V22.712c0-.211-.053-.422-.264-.422h-4.53c-.369,0-.579-.263-.579-.79V16.6a1.119,1.119,0,0,1,1.264-1.054H144.9V11.438c0-.316-.053-.737-.369-.737H132.944a.664.664,0,0,1-.684-.643V4.749c0-2.107.9-2.265,1.211-2.317a91.031,91.031,0,0,1,13.115-.843c2.159,0,7.585,1.106,7.585,2.318V37.089c0,.58,0,1.37-.737,1.37H121.609c-.515-.89-1.1-7.4.233-8.263Z",
          fill: "#ff3ec2"
        })
      ])
    ])
  ])
], -1))
const _hoisted_32 = {
  key: 1,
  class: "textx"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode(" You need a staking "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("account to get started! ")
], -1))
const _hoisted_34 = /*#__PURE__*/_createTextVNode("Create Account")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Button = _resolveComponent("Button")!
  const _component_NFTStaked = _resolveComponent("NFTStaked")!
  const _component_FarmerDisplay = _resolveComponent("FarmerDisplay")!
  const _component_Vault = _resolveComponent("Vault")!
  const _component_ConfigPane = _resolveComponent("ConfigPane")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Loading, { active: _ctx.loading }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.loadingText), 1)
      ]),
      _: 1
    }, 8, ["active"]),
    (_ctx.innerWidthx > 1000)
      ? (_openBlock(), _createElementBlock("video", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    (_ctx.farmerAcc)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_ctx.farmerState === 'staked')
            ? (_openBlock(), _createBlock(_component_NFTStaked, {
                key: _ctx.farmerAcc,
                class: "mb-10",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openPopup = true)),
                vault: _ctx.farmerAcc.vault.toBase58(),
                onSelectedWalletNft: _ctx.handleNewSelectedNFT,
                only: ""
              }, {
                default: _withCtx(() => [
                  (_ctx.farmerState === 'staked')
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        class: "m-top",
                        block: "",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openPopup = true))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.farmerState === 'staked')
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 1,
                        class: "m-top",
                        block: "",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openPopup = true))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["vault", "onSelectedWalletNft"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8)),
          (_ctx.farmerState !== 'staked')
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openPopup = true)),
                class: "btn-add"
              }, "+"))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.getDecimals(_ctx.availableA)) + " $CYRUS", 1),
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.farmerAcc.gemsStaked), 1),
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.parseDate(_ctx.farmerAcc?.minStakingEndsTs)), 1),
            _createVNode(_component_Button, {
              loading: _ctx.claimLoad,
              block: "",
              onClick: _ctx.claim
            }, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            }, 8, ["loading", "onClick"]),
            _createVNode(_component_FarmerDisplay, {
              key: _ctx.farmerAcc,
              farm: _ctx.farm,
              farmAcc: _ctx.farmAcc,
              farmer: _ctx.farmer,
              farmerAcc: _ctx.farmerAcc,
              class: "mb-10",
              onRefreshFarmer: _ctx.handleRefreshFarmer
            }, null, 8, ["farm", "farmAcc", "farmer", "farmerAcc", "onRefreshFarmer"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, _toDisplayString((_ctx.farmAcc.gemsStaked - 100)), 1)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("div", _hoisted_23, _toDisplayString(((_ctx.farmAcc.gemsStaked - 100) / 5555 * 100).toFixed(2)) + " %", 1)
            ])
          ]),
          (_ctx.openPopup)
            ? (_openBlock(), _createBlock(_component_Vault, {
                key: _ctx.farmerAcc,
                class: "vaulx",
                farmerState: _ctx.farmerState,
                vault: _ctx.farmerAcc.vault.toBase58(),
                onSelectedWalletNft: _ctx.handleNewSelectedNFT,
                onMoveimage: _ctx.beginStaking,
                onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openPopup = false)),
                onEndStaking: _ctx.endStaking,
                onAddGems: _ctx.addGems,
                selectedNFTs: _ctx.selectedNFTs,
                onStart: _ctx.start,
                loadingAdd: _ctx.loadingAdd,
                staked: _ctx.farmerAcc.gemsStaked
              }, null, 8, ["farmerState", "vault", "onSelectedWalletNft", "onMoveimage", "onEndStaking", "onAddGems", "selectedNFTs", "onStart", "loadingAdd", "staked"]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _hoisted_28,
            _hoisted_29,
            _hoisted_30,
            _hoisted_31,
            (!_ctx.notStakeAccount)
              ? (_openBlock(), _createBlock(_component_ConfigPane, {
                  key: 0,
                  onSelected: _ctx.handleSelectedWallet
                }, null, 8, ["onSelected"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _hoisted_33,
                  _createVNode(_component_Button, { onClick: _ctx.initFarmer }, {
                    default: _withCtx(() => [
                      _hoisted_34
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]))
          ])
        ]))
  ]))
}